var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCardExpiryCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "98px",
    viewBox: "0 0 95 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage---Activate-Card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5-manage-activate-card",
    transform: "translate(-129.000000, -166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(127.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrative-/-Calendar",
    transform: "translate(11.000000, 17.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1125977,16.7469727 L56.8356445,16.7469727 C59.4243164,16.7469727 61.5231445,18.8458008 61.5231445,21.4344727 L61.5231445,56.7541992 C61.5231445,59.3428711 59.4243164,61.4416992 56.8356445,61.4416992 L19.3356445,61.4416992 C16.7475586,61.4416992 14.6481445,59.3428711 14.6481445,56.7541992 L14.6481445,21.4344727 C14.6481445,18.8458008 16.7475586,16.7469727 19.3356445,16.7469727 L23.025293,16.7469727 M43.6522852,43.3600195 C43.6522852,41.4182227 45.2266992,39.8443945 47.1679102,39.8443945 L48.0462305,39.8438086 C49.9880273,39.8438086 51.5624414,41.4182227 51.5624414,43.3600195 C51.5624414,44.2108008 51.2595117,44.9912695 50.7567773,45.5988867 L43.6522852,53.9063086 L51.5624414,53.9063086 M35.5958789,47.0213672 L40.8687305,47.0213672 M26.3671875,42.1875 L29.0039062,39.84375 L29.0039062,53.90625 L26.3671875,53.90625 L31.640625,53.90625 M32.2265625,16.7469727 L43.9453125,16.7469727 M31.2286523,24.8820117 C31.2286523,26.8232227 29.6542383,28.3976367 27.7130273,28.3976367 C25.7712305,28.3976367 24.1974023,26.8232227 24.1974023,24.8820117 C24.1974023,22.9402148 25.7712305,21.3663867 27.7130273,21.3663867 C29.6542383,21.3663867 31.2286523,22.9402148 31.2286523,24.8820117 Z M51.9407227,24.8820117 C51.9407227,26.8232227 50.3663086,28.3976367 48.4250977,28.3976367 C46.4838867,28.3976367 44.9094727,26.8232227 44.9094727,24.8820117 C44.9094727,22.9402148 46.4838867,21.3663867 48.4250977,21.3663867 C50.3663086,21.3663867 51.9407227,22.9402148 51.9407227,24.8820117 Z M14.6484375,33.316582 L61.5234375,33.316582 M27.7130273,24.8820117 L27.7130273,13.4767383 M48.4250977,24.8820117 L48.4250977,13.4767383",
    id: "Icon"
  })), /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.852201, 73.762682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stamps-/-Arrow-/-Blue",
    transform: "translate(18.147171, 19.436131) rotate(110.000000) translate(-18.147171, -19.436131) translate(12.147171, 10.936131)",
    fill: "#006AFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Blue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0342857143,9.112 C0,9.112 0,9.044 0,9.01 C2.46857143,5.814 5.17714286,2.788 8.12571429,0.034 C8.16,0 8.19428571,0 8.22857143,0 C9.53142857,0.782 10.6628571,1.632 11.6914286,2.618 C11.8971429,2.788 11.8971429,3.094 11.7257143,3.298 L6.65142857,8.602 C6.61714286,8.636 6.61714286,8.67 6.65142857,8.704 C8.16,10.166 10.2857143,12.274 11.7942857,13.736 C11.8285714,13.77 11.8285714,13.804 11.7942857,13.838 L8.50285714,16.898 C8.46857143,16.932 8.43428571,16.932 8.4,16.898 C8.09142857,16.592 2.33142857,11.084 0.0342857143,9.112 Z",
    id: "Path",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.40936379,2.05340137 C1.51220418,1.37179698 0.615857475,7.43050271 4.51301708,7.96063947 C8.64400626,8.52864313 9.3065234,2.77287268 5.40936379,2.05340137 Z",
    id: "Path",
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "translate(5.000000, 5.000000) rotate(61.000000) translate(-5.000000, -5.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(64.837348, 0.811282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7255414,35.668083 C22.5432113,34.6980274 21.2994521,43.9991489 26.5336055,44.5697699 C32.0268753,45.1403908 32.9078715,36.6381387 27.7255414,35.668083 Z",
    id: "Path",
    fill: "#006AFF",
    fillRule: "nonzero",
    transform: "translate(27.170494, 40.097226) rotate(116.000000) translate(-27.170494, -40.097226) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stamps-/-Arrow-/-Light-Pink",
    transform: "translate(15.000000, 15.000000) rotate(314.000000) translate(-15.000000, -15.000000) translate(6.000000, 3.000000)",
    fill: "#FF94CA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Light-Pink"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0514285714,12.864 C0,12.864 0,12.768 0,12.72 C3.70285714,8.208 7.76571429,3.936 12.1885714,0.048 C12.24,0 12.2914286,0 12.3428571,0 C14.2971429,1.104 15.9942857,2.304 17.5371429,3.696 C17.8457143,3.936 17.8457143,4.368 17.5885714,4.656 L9.97714286,12.144 C9.92571429,12.192 9.92571429,12.24 9.97714286,12.288 C12.24,14.352 15.4285714,17.328 17.6914286,19.392 C17.7428571,19.44 17.7428571,19.488 17.6914286,19.536 L12.7542857,23.856 C12.7028571,23.904 12.6514286,23.904 12.6,23.856 C12.1371429,23.424 3.49714286,15.648 0.0514285714,12.864 Z",
    id: "Path",
    fillRule: "nonzero"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardExpiryCalendar);
export default __webpack_public_path__ + "static/media/icon-card-expiry-calendar.36aa41dd.svg";
export { ForwardRef as ReactComponent };